import { c as _c } from "react/compiler-runtime";
import { isEntry } from "@/lib/contentful/guards";
import type { TypeGalleryImage, TypeImageGallery } from "@/types/contentful/generated";
import GalleryImageCard from "./GalleryImageCard";
type GalleryImageEntry = TypeGalleryImage<undefined, string>;
type ImageGalleryFields = TypeImageGallery<undefined, string>["fields"];
interface Props {
  layout: ImageGalleryFields["layout"];
  images: ImageGalleryFields["images"];
}
export default function ImageGallery(t0) {
  const $ = _c(6);
  const {
    layout,
    images
  } = t0;
  let t1;
  if ($[0] !== images || $[1] !== layout) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const entries = images.filter(_temp);
      if (entries.length === 0) {
        t1 = null;
        break bb0;
      }
      if (layout === "1 Image (Full-width)") {
        t1 = <section className="mx-auto w-full max-w-site-content px-6 py-6"><GalleryImageCard entry={entries[0]} isFullWidth={true} /></section>;
        break bb0;
      }
      if (layout === "2 images (Two-up row)") {
        t1 = <section className="mx-auto w-full max-w-site-content px-6 py-6"><div className="grid grid-cols-1 gap-6 md:grid-cols-2">{entries.slice(0, 2).map(_temp2)}</div></section>;
        break bb0;
      }
      if (layout === "3 Images (Full-width on top)") {
        t1 = <section className="mx-auto flex w-full max-w-site-content flex-col gap-6 px-6 py-6"><GalleryImageCard entry={entries[0]} isFullWidth={true} /><div className="grid grid-cols-1 gap-6 md:grid-cols-2">{entries.slice(1, 3).map(_temp3)}</div></section>;
        break bb0;
      }
      if (layout === "3 Images (Full-width on bottom)") {
        const bottomImage = entries[2];
        const t2 = <div className="grid grid-cols-1 gap-6 md:grid-cols-2">{entries.slice(0, 2).map(_temp4)}</div>;
        const t3 = bottomImage && <GalleryImageCard entry={bottomImage} isFullWidth={true} />;
        let t4;
        if ($[3] !== t2 || $[4] !== t3) {
          t4 = <section className="mx-auto flex w-full max-w-site-content flex-col gap-6 px-6 py-6">{t2}{t3}</section>;
          $[3] = t2;
          $[4] = t3;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        t1 = t4;
        break bb0;
      }
    }
    $[0] = images;
    $[1] = layout;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  return null;
}
function _temp4(entry_1) {
  return <GalleryImageCard key={entry_1.sys.id} entry={entry_1} />;
}
function _temp3(entry_0) {
  return <GalleryImageCard key={entry_0.sys.id} entry={entry_0} />;
}
function _temp2(entry) {
  return <GalleryImageCard key={entry.sys.id} entry={entry} />;
}
function _temp(img) {
  return isEntry(img);
}